import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Badge, Card, Icon, Collapse, Tag, List, Row, Col, Divider, Input, Button } from 'antd';
import { EmptyData, DecosFunc } from 'components/utils';
import { connect } from 'react-redux';
import * as actions from 'actions';
import './DecosList.css';
import * as services from 'services';
import { notification } from 'components/utils';

const Panel = Collapse.Panel;

const customPanelStyle = {
	selected: {
		borderRadius: 4,
		marginLeft: 5,
		marginRight: 5,
		marginBottom: 5,
		padding: '0!important',
		border: '1px solid #596674',
		overflow: 'hidden',
	},
	unselected: {
		borderRadius: 4,
		marginLeft: 5,
		marginRight: 5,
		marginBottom: 5,
		padding: '0!important',
		border: '1px solid #e8e8e8',
		overflow: 'hidden',
	},
};

const SelectedHeader = props => {
	return (
		<Card
			size="small"
			style={{ background: '#596674', border: 0, borderRadius: 0 }}
			bodyStyle={{ padding: 0, margin: 0 }}
			headStyle={{ borderBottom: 0 }}
			title={
				<Row type="flex" justify="start" align="middle" style={{ padding: '0px', margin: '0px' }}>
					<Col span={2}>
						<Badge color="#fff" />
					</Col>
					<Col span={14} style={{ padding: '0px' }}>
						<span style={{ fontWeight: '500', color: '#fff' }}>{props.title}</span>
					</Col>
				</Row>
			}
		/>
	);
};

const UnSelectedHeader = props => {
	return (
		<Card
			size="small"
			style={{ border: 0 }}
			bodyStyle={{ padding: 0 }}
			title={
				<Row type="flex" justify="start" align="middle" style={{ padding: '0px', margin: '0px' }}>
					<Col span={2}>
						<Badge status="default" />
					</Col>
					<Col span={14} style={{ padding: '0px' }}>
						<span style={{ fontWeight: '500' }}>{props.title}</span>
					</Col>
				</Row>
			}
		/>
	);
};

const mapStateToProps = state => ({
	decos: state.spell.decos,
	selectedItem: state.spell.selectedItem,
	searchFilter: state.spell.searchFilter,
	text: state.info.text,
});

const mapDispatchToProps = dispatch => ({
	onSelectedItem: selectedItem => dispatch(actions.onSelectedItem(selectedItem)),
	onReplaceItem: replaceItem => dispatch(actions.onReplaceItem(replaceItem)),
	onDisableItem: disableItem => dispatch(actions.onDisableItem(disableItem)),
});

const fetchLogSave = async datas => {
	await services.postApi(this, '/api/sentence/spell', datas);
	return true;
};

class DecosList extends Component {
	state = {
		decos: [],
	};

	constructor(props) {
		super(props);
		const { decos, selectedItem, searchFilter } = this.props;
		const _decos = DecosFunc.decosBySearch(searchFilter, decos);
		this.state = {
			title: props.post.title,
			decos: _decos,
			error: '',
			selectedItem,
			height: 0,
			isChangeSelectedItem: true,
		};
		this.myRef = React.createRef();
		this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
	}

	updateWindowDimensions() {
		this.setState({ width: window.innerWidth, height: window.innerHeight });
	}

	componentDidMount() {
		this.updateWindowDimensions();
		window.addEventListener('resize', this.updateWindowDimensions);
	}

	onChange = key => {
		if (key != null) {
			const { decos } = this.state;
			const item = decos[key];
			const selectedItem = {
				blockKey: item.blockKey,
				start: item.start,
				end: item.end,
				text: item.orgStr,
				scrollNo: true,
			};
			this.props.onSelectedItem(selectedItem);
			this.setState({ selectedItem, selectedKey: key });
		}
	};

	onClickDisableItem = (e, key) => {
		e.stopPropagation();
		this.props.onDisableItem(key);
		const board = window.sessionStorage.getItem('board');
		const USER = JSON.parse(window.sessionStorage.getItem('user'));
		var line = this.props.text.split('.').filter(x => x.indexOf(key));

		let datas = {
			status: '무시',
			source: key,
		};

		if (USER != null) {
			datas = Object.assign({}, datas, { userId: USER.id });
		}
		if (board != null) {
			datas = Object.assign({}, datas, { board: parseInt(board) });
		}
		if (line[0] != null) {
			datas = Object.assign({}, datas, { line: line[0] });
		}
		fetchLogSave(datas);
	};

	onChangeError = e => {
		if (e.target.value.length < 100) {
			this.setState({ error: e.target.value });
		} else {
			notification.openNotificationWithIcon('error', '100자 내로 입력해 주세요.', null);
		}
	};

	onAlertError = (e, key) => {
		e.stopPropagation();
		if (this.state.error.trim() !== '') {
			const board = window.sessionStorage.getItem('board');
			const USER = JSON.parse(window.sessionStorage.getItem('user'));
			var line = this.props.text.split('.').filter(x => x.indexOf(key));

			let datas = {
				status: '오류신고',
				source: key,
				comment: this.state.error,
			};

			if (USER != null) {
				datas = Object.assign({}, datas, { userId: USER.id });
			}
			if (board != null) {
				datas = Object.assign({}, datas, { board: parseInt(board) });
			}
			if (line[0] != null) {
				datas = Object.assign({}, datas, { line: line[0] });
			}
			fetchLogSave(datas);
		} else {
			notification.openNotificationWithIcon('error', '오류신고 내용을 입력해 주세요.', null);
		}
	};

	onReplaceClickItem = (e, item, text) => {
		this.props.onReplaceItem({
			blockKey: item.blockKey,
			start: item.start,
			end: item.end,
			text: text,
			orgStr: item.orgStr,
		});
	};

	onScroll = e => {};

	componentWillReceiveProps(nextProps) {
		const { decos, selectedItem, post, searchFilter } = nextProps;

		const _decos = DecosFunc.decosBySearch(searchFilter, decos);
		this.setState({ decos: _decos, selectedItem, title: post.title, isChangeSelectedItem: true });
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.isChangeSelectedItem) {
			const { selectedItem, decos } = this.state;
			const _keys = decos
				.map((item, index) => {
					if (
						selectedItem != null &&
						item.orgStr === selectedItem.text &&
						parseInt(item.start) === parseInt(selectedItem.start)
					) {
						return index;
					} else {
						return null;
					}
				})
				.filter(x => x != null);

			if (_keys != null && _keys.length > 0) {
				if (this.myRef.current.scrollTop != null && !selectedItem.scrollNo) {
					this.myRef.current.scrollTop = _keys[0] * 40;
				}
				this.setState({ selectedKey: _keys[0].toString(), isChangeSelectedItem: false });
			} else {
				this.setState({ selectedKey: '', isChangeSelectedItem: false });
			}
			this.setState({ isChangeSelectedItem: false });
		}
	}

	render() {
		const { decos, title, selectedKey } = this.state;

		return (
			<Fragment>
				<div style={{ height: '100%' }}>
					<Card title={title} style={{ height: '100%' }}>
						<div className={'decocontent'} onScroll={this.onScroll} ref={this.myRef}>
							{decos && decos.length > 0 && (
								<Collapse
									accordion
									bordered={false}
									onChange={this.onChange}
									defaultActiveKey={[selectedKey]}
									activeKey={[selectedKey]}
								>
									{decos.map((item, idx) => {
										return (
											<Panel
												showArrow={false}
												header={
													parseInt(selectedKey) === idx ? (
														<SelectedHeader title={item.orgStr} />
													) : (
														<UnSelectedHeader title={item.orgStr} />
													)
												}
												key={idx}
												style={
													parseInt(selectedKey) === idx
														? customPanelStyle.selected
														: customPanelStyle.unselected
												}
											>
												<div
													style={{
														padding: '8px 10px',
														margin: '0',
													}}
												>
													<List
														dataSource={item.candWord}
														locale={{
															emptyText: '대치어가 없습니다.',
														}}
														renderItem={cand => (
															<List.Item>
																<Tag
																	color=""
																	style={{ fontSize: '10px', lineHeight: '12px' }}
																>
																	대치어
																</Tag>
																<Link
																	to="#"
																	onClick={e =>
																		this.onReplaceClickItem(e, item, cand)
																	}
																>
																	{cand}
																</Link>
															</List.Item>
														)}
													/>
													<Divider />
													<Tag color="" style={{ fontSize: '10px', lineHeight: '12px' }}>
														도움말
													</Tag>
													{
														<span
															dangerouslySetInnerHTML={{
																__html: item.help,
															}}
														/>
													}
													<Divider />
													<Row span={16} type="flex" justify="start" align="middle">
														<Col span={7}>
															<Button
																size="small"
																onClick={e => this.onClickDisableItem(e, item.orgStr)}
																style={{ borderColor: 'green' }}
															>
																<Icon type="delete" />
																무시하기
															</Button>
														</Col>
														<Col span={1}>&nbsp;</Col>
														<Col span={15}>&nbsp;</Col>
													</Row>
													<Divider />
													<Row span={16} type="flex" justify="space-between" align="middle">
														<Col span={7}>
															<Button
																size="small"
																style={{ borderColor: 'red' }}
																onClick={e => this.onAlertError(e, item.orgStr)}
															>
																<Icon type="bell" />
																오류신고
															</Button>
														</Col>
														<Col span={1}>&nbsp;</Col>
														<Col span={15}>
															<Input
																prefix={
																	<Icon
																		type="edit"
																		style={{
																			color: 'rgba(0,0,0,.25)',
																		}}
																	/>
																}
																name="error"
																placeholder="오류에 대한 의견을 적어 주세요."
																style={{ fontSize: '10px' }}
																value={this.state.error}
																onChange={this.onChangeError}
															/>
														</Col>
													</Row>
												</div>
											</Panel>
										);
									})}
								</Collapse>
							)}
							{decos && decos.length <= 0 && (
								<EmptyData message={(title === '전체' ? '맞춤법 오류' : title) + '가 없습니다.'} />
							)}
							 
							{!decos && (
								<EmptyData message={(title === '전체' ? '맞춤법 오류' : title) + '가 없습니다.'} />
							)}
						</div>
					</Card>
				</div>
			</Fragment>
		);
	}
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(DecosList);
